import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  settingsHelpQR: {
    height: Theme.px(300),
    marginTop: Theme.px(52),
    width: Theme.px(300),
  },
  settingsHelpText: {
    fontSize: Theme.px(36),
    lineHeight: Theme.px(48),
  },
  settingsHelpUrl: {
    fontSize: Theme.px(42),
    lineHeight: Theme.px(55),
    marginTop: Theme.px(6),
  },
  settingsHelpWrapper: {
    alignItems: 'flex-start',
  },
  wrapper: {
    paddingTop: Theme.px(261),
  },
});
